import axios from 'axios';

export default class {
  #news = null;
  #id = '';
  id = '';

  get badge() {
    if (!this.id) return false;
    return this.id !== this.#id;
  }

  init(params) {
    return axios
      .get('/tourclient/api/news')
      .then(({ data }) => {
        this.#id = params.MagReadNewsIds || '';
        this.id = data.items?.[0]?.id || '';
        const items = (data.items || [])
          .map((i) => {
            const date = new Date(i.date);
            return {
              label: i.title,
              value: i.id,
              link: `/tourclient/app/#/agency-news/${i.id}`,
              date,
              type: 'Agency',
            };
          })
          .sort((a, b) => b.value - a.value);

        const isNewsPage = window.location.pathname === '/tourclient/app/' && window.location.hash.startsWith('#/agency-news');

        let availableNews = data.items.filter(i => !~this.#id.split(',').map(j => +j).indexOf(i.id));

        if (availableNews.length && !isNewsPage) {
          const selectedId = availableNews[0].id;
          this.id = selectedId;
          return axios
            .get('/tourclient/api/news/' + selectedId)
            .then((itemResponse) => {
              const news =  {
                date: availableNews[0].date,
                body: itemResponse.data.item.description,
                title: itemResponse.data.item.title,
                url: '/tourclient/app/#/agency-news/' + selectedId,
              };

              return { items, news };
          });
        }

        return { items };
      });
  }

  getNews() {
    return Promise.resolve(this.#news);
  }

  read() {
    if (this.id === this.#id) {
      return Promise.resolve();
    }
    return axios
      .post('/tourclient/account/SetNewsRead', `ids=${this.id}&ownNews=false`)
      .then(() => {
        this.#id = this.id;
      });
  }
}
